import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Route, Routes } from 'react-router-dom'
import Page404 from 'src/pages/Page404'
const Content = ({ routes }) => {
  return (
    <>
      <Suspense>
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Suspense>
    </>
  )
}
Content.propTypes = {
  routes: PropTypes.array,
}
export default React.memo(Content)
